const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REDIRECT_URL: process.env.REACT_APP_REDIRECT_URL,
  POSTREDIRECT_URL: process.env.REACT_APP_POSTREDIRECT_URL,
  AZURE_CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID,
  AZURE_TENANT_ID: process.env.REACT_APP_AZURE_TENANT_ID,
};
export default config;
